import React from 'react';
import Webform from 'gatsby-drupal-webform';
import {WebformInput, WebformRadios} from '../../webform/element';
import {navigate} from 'gatsby';

interface DataContext {
  additionalData: {
    allWebforms: Queries.webform__webform[];
  };
}

export default function CityScan({additionalData}: DataContext): React.JSX.Element {
  const endpoint = process.env.DRUPAL_SOURCE + 'react_webform_backend/submit';
  const webformWebform = additionalData.allWebforms.find((item: Queries.webform__webform) => {
    return item.drupal_internal__id === 'city_scan';
  });

  const elem = (
    <section className="vl-region">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          <div className="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s">
            <div className="vl-steps vl-steps--has-line">
              <ul className="vl-steps__list">
                <Webform
                  noValidate={true}
                  webform={webformWebform}
                  endpoint={endpoint}
                  customComponents={{
                    textfield: WebformInput,
                    email: WebformInput,
                    radios: WebformRadios,
                  }}
                  onSubmit={() => {
                    document.querySelector('.loader-overlay')?.classList.remove('hidden');
                  }}
                  onSuccess={(response) => {
                    document.querySelector('.loader-overlay')?.classList.add('hidden');
                    navigate(response.settings.confirmation_url);
                  }}
                  onValidate={(e) => {
                    let hasValidationErrors = false;

                    const elementsToValidate = e.target.querySelectorAll(`[data-vl-error-message]`);

                    elementsToValidate.forEach((element) => {
                      const messageContainer = e.target.querySelector(`[data-vl-error-id="${element.name}-error"]`);
                      const inputErrorClass = element.dataset.vlErrorClass;

                      if (!messageContainer) {
                        return;
                      }

                      element.classList.remove(inputErrorClass);
                      messageContainer.innerHTML = '';

                      if (!element.checkValidity()) {
                        hasValidationErrors = true;
                        element.classList.add(inputErrorClass);
                        messageContainer.innerHTML = element.dataset.vlErrorMessage;
                      }
                    });

                    return !hasValidationErrors;
                  }}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return elem;
}
